// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a5ea9ce1","359":"bfcb2ed9","545":"295fbbcf","787":"f89128b7"}[chunkId] + ".chunk.js";
};